<template xmlns="http://www.w3.org/1999/html">
  <div class="qinhuangdao">
    <HeaderTop title="金风科技在秦皇岛"></HeaderTop>
    <!--  地图上的县  -->
    <ul class="map-point-list">
      <li v-for="(item, index) in cityList" :key="item.name"
          :class="{
              'is-active': curCounty['标题'] && curCounty['标题'].includes(item.name),
              'green': item.name == '北戴河区',
              'freezen': !item['弹窗'] }"
          :style="{ left: item.left + 'vw', top: item.top + 'vh' }"
          @click.stop="openCounty(item, index)">
        <p class="name">{{ item.name }}</p>
        <span class="point"></span>
        <span class="circle"></span>
      </li>
    </ul>
    <!--  地图上的点 弹窗  -->
    <transition name="el-zoom-in-center">
      <div v-show="isShowCounty" class="fixed-dialog county"
        :class="curCounty.position">
        <i class="el-icon-close" @click.stop="closeCounty"></i>
        <el-icon class="icon-close"></el-icon>
        <div class="pic-panel county">
          <div class="header"></div>
          <div class="body">
            <div class="title">{{ curCounty['标题'] }}</div>
            <div class="info" v-html="curCounty['概况']"></div>
            <el-button v-if="cityList.length && cityList[curCountyIndex]['大事记']"
                class="go-county" type="text" @click.stop="goCounty">详情 <i class="el-icon-right"></i></el-button>
          </div>
        </div>
      </div>
    </transition>
    <!--  右侧 战略支撑  -->
    <div class="side-right">
      <div class="fixed" @click.stop="isOpenZhanlue = !isOpenZhanlue">
        <img src="../assets/img/icon-zhanlue.png" alt="">
        <h4 class="title">战略支撑</h4>
      </div>
      <el-collapse-transition>
        <ul v-show="isOpenZhanlue" class="expanded-list">
          <li class="second-title" @click.stop="openZhanlue1">经济技术开发区（东区）<br/>北方海上风电产业基地</li>
          <li class="second-title" @click.stop="openZhanlue2">抚宁区<br/>北方储能旗舰工厂</li>
        </ul>
      </el-collapse-transition>
      <div class="fixed" @click.stop="goYunying">
        <img src="../assets/img/icon-yunying.png" alt="">
        <h4 class="title" :style="{ lineHeight: $px2rem('27px') }">金风科技在<br/>秦皇岛大事记</h4>
      </div>
    </div>
    <transition name="el-zoom-in-center">
      <!--  右侧 战略支撑-开发区东区产业基地 弹窗 -->
      <el-dialog :visible.sync="zlDialog.isShow" custom-class="zhanlue" :show-close="false" :destroy-on-close="true" :style="{backgroundUrl: 'url(' + zlDialog.current['背景图'] + ')'}"
               :modal-append-to-body="false"
               :fullscreen="true" :align-center="true">
      <img class="bg" :src="zlDialog.current['背景图']" alt="">
      <h3 class="title top">{{ zlDialog.current['标题'] }}</h3>
      <div class="tag-group">
        <div @click.stop="openGuanhuai">领导关怀</div>
        <!--      <div :class="{'is-active': curTurbineType === '海上' }" @click="toggleTurbineType('海上')">海上风电项目</div>-->
      </div>
      <ul v-if="zlDialog.current && zlDialog.current['四集群']" class="map-point-list zhanlue">
        <li v-for="item in zlDialog.current['四集群']" :key="item.name"
            :class="{'is-active': item.name === curJiqun.name }"
            :style="{ left: item.left + 'vw', top: item.top + 'vh' }"
            @click.stop="openJiqun(item)">
          <p class="name">{{ item.name }}</p>
          <span class="point"></span>
          <span class="circle"></span>
        </li>
      </ul>
      <div class="zhanlue-light" v-if="zlDialog.current['大事记']">
        <ul :style="{ width: $px2rem(zlDialog.current['大事记'].length * 300 + 'px') }">
          <li v-for="item in zlDialog.current['大事记']" :key="item['标题']"
              :class="{'has-img': item['图片'] && item['图片'].length > 0 }"
              @click.stop="openJiqun(item)">
            <h4 class="date">{{ item['时间'] }}</h4>
            <p class="event-title">{{ item['标题'] }}</p>
          </li>
        </ul>
      </div>
      <transition name="el-zoom-in-center">
        <div v-show="isShowJiqunDialog" class="fixed-dialog jiqun">
          <i class="el-icon-close" @click.stop="closeJiqun"></i>
          <div class="jiqun-panel">
            <div class="header">{{ curJiqun['标题'] }}</div>
            <div class="info">{{ curJiqun['简介'] }}</div>
<!--            <div class="img-box">-->
<!--              <div class="img" v-for="item in curJiqun['图片']" :key="item">-->
<!--                <img :src="item" alt="">-->
<!--&lt;!&ndash;                <p class="attr">{{ item.attr }}</p>&ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->

            <el-carousel trigger="click"
                         :autoplay="false"
                         :arrow="(curJiqun['图片'] && curJiqun['图片'].length > 1) ? 'always' : 'never'"
                         indicator-position="none">
              <el-carousel-item v-for="item in curJiqun['图片']" :key="item">
                <img :src="item" alt="">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </transition>
      <transition name="el-zoom-in-center">
        <div v-show="isShowGuanhuai" class="fixed-dialog jiqun">
          <i class="el-icon-close" @click.stop="closeGuanhuai"></i>
          <div class="jiqun-panel">
            <div class="header">领导关怀</div>
            <el-carousel trigger="click"
                         :autoplay="false"
                         :arrow="(zlDialog.current['领导关怀'] && zlDialog.current['领导关怀'].length > 1) ? 'always' : 'never'"
                         indicator-position="none">
              <el-carousel-item v-for="item in zlDialog.current['领导关怀']" :key="item['简介']">
                <div class="info">{{ item['简介'] }}</div>
                <img v-if="item['图片'] && item['图片'].length > 0" :src="item['图片'][0]" alt="">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>

      </transition>
      <el-button class="go-back" type="text"
                 @click.stop="closeZhanlue"
      ><i class="el-icon-back"></i>返回</el-button>
    </el-dialog>
    </transition>
    <!--  底部 三个 slogan  -->
    <div class="slogan">
      <div v-for="(item, index) in qinhuangdao['SLOGAN']" :key="item + index" class="slogan-item">
        <img src="../assets/img/slogan.png" alt="">
        <h4>{{ item }}</h4>
      </div>
    </div>
    <el-button class="go-back" type="text" @click.stop="goBack">
      <i class="el-icon-back"></i>返回
    </el-button>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'qinhuangdao',
  data () {
    return {
      qinhuangdao: this.$store.state.page.pageConfig['金风科技在秦皇岛'],
      isOpenZhanlue: false,
      dialog: { // 时间线
        isShow: false,
        title: '',
        timelineIndex: 0
      },
      zlDialog: { // 战略-开发区
        isShow: false,
        title: '',
        stepIndex: null,
        current: {}
      },
      isShowJiqunDialog: false,
      curCounty: {},
      curCountyIndex: 0,
      isShowCounty: false,
      curTimeline: {},
      curJiqun: {},
      isShowGuanhuai: false,
    }
  },
  computed: {
    ...mapState(['pageConfig']),
    timeline () {
      return this.updateTimeline()
    },
    cityList () {
      return this.qinhuangdao['城市列表']
    },
    zhanlue () {
      return this.qinhuangdao['战略支撑']
    },
    zhanlue1 () {
      return this.zhanlue['开发区（东区）北方海上风电产业基地']
    },
    zhanlue2 () {
      return this.zhanlue['抚宁北方储能旗舰工厂']
    },
  },
  components: {
    HeaderTop: () => import('/src/components/HeaderTop'),
    // TimelineCarousel: () => import('/src/components/TimelineCarousel')
  },
  props: [],
  mounted () {},
  methods: {
    // updateTimeline () {
    //   return this.qinhuangdao['大事记'].reverse()
    // },
    openDialog (item, index) {
      this.curTimeline = item
      this.dialog.timelineIndex = index
      this.dialog.isShow = true
      this.closeCounty()
      this.$refs.timelineCarousel.pauseAuto()
    },
    closeDialog (done) {
      this.$refs.timelineCarousel.autoPlay()
      done()
    },
    prevTimeline () {
      if (this.dialog.timelineIndex === 0) {
        this.dialog.timelineIndex = this.timeline.length - 1
      } else {
        this.dialog.timelineIndex--
      }
      this.curTimeline = this.timeline[this.dialog.timelineIndex]
      this.$refs.timelineCarousel.setVisibleItems(this.dialog.timelineIndex)
    },
    nextTimeline () {
      if (this.dialog.timelineIndex === this.timeline.length - 1) {
        this.dialog.timelineIndex = 0
      } else {
        this.dialog.timelineIndex++
      }
      this.curTimeline = this.timeline[this.dialog.timelineIndex]
      this.$refs.timelineCarousel.setVisibleItems(this.dialog.timelineIndex)
    },
    openCounty (item, index) {
      this.curCountyIndex = index
      if (item['项目简介']) {
        this.goCounty()
      } else {
        this.curCounty = item['弹窗']
        this.isShowCounty = true
      }
    },
    closeCounty () {
      this.curCountyIndex = 0
      this.curCounty = {}
      this.isShowCounty = false
    },
    goCounty () {
      this.$store.commit('page/SET_CURCOUNTY', this.cityList[this.curCountyIndex])
      this.$router.push()
    },
    openZhanlue1 () {
      this.zlDialog.isShow = true
      this.zlDialog.current = this.zhanlue1
    },
    openZhanlue2 () {
      this.zlDialog.isShow = true
      this.zlDialog.current = this.zhanlue2
    },
    closeZhanlue () {
      this.zlDialog.isShow = false
      this.closeJiqun()
    },
    zhanlueToggle () {
      const vm = this
      if (this.zlDialog.stepIndex < 3) {
        this.zlDialog.stepIndex = this.zlDialog.stepIndex + 0.5
        setTimeout(function (){
          vm.zlDialog.stepIndex = vm.zlDialog.stepIndex + 0.5
        }, 1000)
      }
    },
    openJiqun (item) {
      this.curJiqun = item
      if (item['简介'] || item['图片']) {
        this.isShowJiqunDialog = true
      }
    },
    closeJiqun () {
      this.curJiqun = {}
      this.isShowJiqunDialog = false
    },
    openGuanhuai () {
      this.isShowGuanhuai = true
    },
    closeGuanhuai () {
      this.isShowGuanhuai = false
    },
    goBack () {
      this.$emit('prev')
    },
    goYunying () {
      this.$emit('next')
    }
  },
  watch: {}

}
</script>
<style lang="scss" scoped>
@import "~/src/assets/css/common.scss";

.qinhuangdao {
  width: 100vw;
  height: 100vh;
  background: url("/resource/img/qinhuangdao.png") no-repeat center / cover;

  .handle-button {
    width: 100vw;
    display: flex;
    justify-content: space-between;

    .el-button {
      position: fixed;
      top: 50%;
      transform: translateY(-50%);
      background: transparent !important;
      border-color: transparent !important;
      font-size: 50px;
      color: #ffffff;
      z-index: 1;

      &:first-child {
        left: 50%;
        margin-left: -49vw;
      }

      &:last-child {
        right: 50%;
        margin-right: -49vw;
      }
    }
  }

  .side-right {
    position: fixed;
    right: 90px;
    top: 15vh;
    cursor: pointer;
    .fixed {
      display: flex;
      align-items: center;
    }

    img {
      width: 80px;
    }

    .title {
      width: 210px;
      height: 58px;
      font-size: 20px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 55px;
      padding-left: 40px;
      padding-right: 40px;
      background: url("../assets/img/icon-zhanlue-bg.png") no-repeat center right;
      background-size: 210px 58px;
      margin-left: -24px;
      box-sizing: border-box;
    }
    .expanded-list {
      margin-bottom: 50px;
      padding-left: 45px;
    }
    .second-title {
      width: 180px;
      padding-left: 30px;
      margin-top: 32px;
      list-style: none;
      position: relative;
      height: 60px;
      background: linear-gradient( 90deg, rgba(0,90,255,0) 0%, rgba(0,90,255,0.24) 50%, rgba(0,90,255,0) 100%);
      border-radius: 12px;
      border: 1px solid;
      border-image: linear-gradient(90deg, rgba(0, 101, 255, 0), rgba(72, 150, 255, 1), rgba(0, 48, 255, 0)) 1 1;
      font-weight: 400;
      color: #FFFFFF;
      text-shadow: 0px 0px 10px rgba(30,198,255,0.8);
      font-style: normal;
      white-space: nowrap;
      box-sizing: border-box;
      line-height: 22px;
      font-size: 18px;
      padding-top: 7px;
      &::before {
        content: "";
        display: inline-block;
        width: 2px;
        height: 48px;
        background: #00AAFF;
        position: absolute;
        left: -2px;
        top: 6px;
      }
    }
  }

  ::v-deep .el-dialog {
    &.zhanlue {
      width: 100vw;
      height: 100vh;
      background: url("/resource/img/zhanlue1.jpg") no-repeat center / 100% 100%;

      .tag-group{
        left: unset;
        right: 0px;
        bottom: 250px;
        div {
          width: 178px;
        }
      }

      > .el-dialog__header {
        display: none;
      }

      > .el-dialog__body {
        height: 100vh;
        padding: 0;
        //background: rgba(0,0,0,.3);
        &::before {
          content: "";
          display: block;
          height: 100vh;
          width: 100vw;
          position: absolute;
          top: 0;
          left: 0;
          background: linear-gradient(180deg, rgba(20, 57, 129, 0.57) 0%, rgba(5, 15, 34, 0) 13%, rgba(5, 15, 34, 0) 74%, rgba(5, 15, 34, 0.8) 100%);
          z-index: 1;
        }
        * {
          z-index: 2;
        }
      }
      .bg {
        width: 100vw;
        height: 100vh;
        position: absolute;
        z-index: 0;
      }
      .zhanlue-contain{
        width: 100vw;
        height: 100vh;
      }
      .page1 {
        position: absolute;
        bottom: 60px;
        left: 50%;
        transform: translateX(-50%);
      }

      .page2 {
        width: 100%;
        height: 100vh;
        position: relative;

        .title.top {
          position: absolute;
          left: 50px;
          top: 50px;
        }

        .sub-title {
          position: absolute;
          bottom: 50px;
        }
      }

      .title {
        height: 70px;
        font-size: 40px;
        font-weight: 800;
        color: #FFFFFF;
        line-height: 105px;
        text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.5);

        &.top {
          position: absolute;
          left: 50px;
          top: 10px;
          font-size: 32px;
        }

        &.bottom {
          text-align: center;
        }
      }

      .sub-title {
        width: 76vw;
        margin: 40px 12vw;
        font-size: 28px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 50px;
        text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.5);
      }

      //.jiqun-back{
      //  position: absolute;
      //  left: 50px;
      //  bottom: 50px;
      //  font-size: 24px;
      //  font-weight: 400;
      //  color: #FFFFFF;
      //  line-height: 36px;
      //}
    }
  }

  .slogan{
    position: fixed;
    right: 150px;
    bottom: 10%;
    //display: flex;
    //justify-content: center;
    .slogan-item {
      white-space: nowrap;
      &:nth-child(2) {
        margin-left: -6vw;
      }
      &:nth-child(3) {
        margin-left: -14vw;
      }
    }
    img, h4 {
      display: inline-block;
      vertical-align: middle;
    }
    img {
      width: 63px;
    }
    h4 {
      display: inline-block;
      margin-left: -40px;
      font-weight: bold;
      font-size: 20px;
      color: #FFFFFF;
      line-height: 46px;
      text-shadow: 0px 0px 10px rgba(0,0,0,0.4);
      font-style: normal;
    }
  }
}
</style>
